import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  TextField,
  InputAdornment,
} from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import SearchIcon from '@mui/icons-material/Search';
import StarIcon from '@mui/icons-material/Star';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import IconButton from '@mui/material/IconButton';

const DEFAULT_CATEGORIES = [
  { id: 1, name: 'Necklaces', slug: 'necklaces' },
  { id: 2, name: 'Earrings', slug: 'earrings' },
  { id: 3, name: 'Rings', slug: 'rings' },
  { id: 4, name: 'Bangles', slug: 'bangles' },
  { id: 5, name: 'Chains', slug: 'chains' },
  { id: 6, name: 'Pendants', slug: 'pendants' },
  { id: 7, name: 'Coins & Bars', slug: 'coins-bars' },
  { id: 8, name: 'Pooja Items', slug: 'pooja-items' },
];

const DEFAULT_PRODUCTS = [
  { id: 1, name: 'Royal Silver Necklace', category: 'Necklaces', categorySlug: 'necklaces', price: 12500, weight: '45g', purity: '925 Silver', image: 'https://images.pexels.com/photos/1454171/pexels-photo-1454171.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: true, is_new_arrival: false, description: 'Elegant royal silver necklace with intricate traditional design.' },
  { id: 2, name: 'Temple Jhumka Earrings', category: 'Earrings', categorySlug: 'earrings', price: 4800, weight: '18g', purity: '925 Silver', image: 'https://images.pexels.com/photos/1232931/pexels-photo-1232931.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: true, is_new_arrival: true, description: 'Traditional temple jhumka earrings in pure silver.' },
  { id: 3, name: 'Silver Toe Ring Set', category: 'Rings', categorySlug: 'rings', price: 1200, weight: '8g', purity: '925 Silver', image: 'https://images.pexels.com/photos/2735970/pexels-photo-2735970.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: false, is_new_arrival: true, description: 'Beautiful silver toe ring set for brides.' },
  { id: 4, name: 'Classic Silver Bangle', category: 'Bangles', categorySlug: 'bangles', price: 8500, weight: '35g', purity: '925 Silver', image: 'https://images.pexels.com/photos/177332/pexels-photo-177332.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: true, is_new_arrival: false, description: 'Classic silver bangle with fine engraving.' },
  { id: 5, name: 'Elegant Silver Chain', category: 'Chains', categorySlug: 'chains', price: 3200, weight: '15g', purity: '925 Silver', image: 'https://images.pexels.com/photos/168927/pexels-photo-168927.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: false, is_new_arrival: false, description: 'Lightweight elegant silver chain for daily wear.' },
  { id: 6, name: 'Peacock Silver Pendant', category: 'Pendants', categorySlug: 'pendants', price: 2800, weight: '12g', purity: '925 Silver', image: 'https://images.pexels.com/photos/2849742/pexels-photo-2849742.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: true, is_new_arrival: true, description: 'Stunning peacock design pendant in pure silver.' },
  { id: 7, name: 'Silver Coin 10g', category: 'Coins & Bars', categorySlug: 'coins-bars', price: 950, weight: '10g', purity: '999 Silver', image: 'https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: false, is_new_arrival: false, description: 'Pure silver coin, ideal for gifting and investment.' },
  { id: 8, name: 'Silver Pooja Plate', category: 'Pooja Items', categorySlug: 'pooja-items', price: 15000, weight: '100g', purity: '925 Silver', image: 'https://images.pexels.com/photos/2442893/pexels-photo-2442893.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: true, is_new_arrival: false, description: 'Beautifully crafted silver pooja plate for auspicious occasions.' },
  { id: 9, name: 'Bridal Choker Necklace', category: 'Necklaces', categorySlug: 'necklaces', price: 22000, weight: '65g', purity: '925 Silver', image: 'https://images.pexels.com/photos/691046/pexels-photo-691046.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: true, is_new_arrival: true, description: 'Stunning bridal choker necklace with stone work.' },
  { id: 10, name: 'Stud Earrings Set', category: 'Earrings', categorySlug: 'earrings', price: 1800, weight: '6g', purity: '925 Silver', image: 'https://images.pexels.com/photos/371285/pexels-photo-371285.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: false, is_new_arrival: true, description: 'Minimalist silver stud earrings for everyday elegance.' },
  { id: 11, name: 'Antique Silver Ring', category: 'Rings', categorySlug: 'rings', price: 2200, weight: '10g', purity: '925 Silver', image: 'https://images.pexels.com/photos/230290/pexels-photo-230290.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: false, is_new_arrival: false, description: 'Vintage-style antique silver ring with detailed craftsmanship.' },
  { id: 12, name: 'Silver Kada Bangle', category: 'Bangles', categorySlug: 'bangles', price: 6500, weight: '28g', purity: '925 Silver', image: 'https://images.pexels.com/photos/3266700/pexels-photo-3266700.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: true, is_new_arrival: false, description: 'Traditional silver kada bangle with intricate motifs.' },
  { id: 13, name: 'Silver Lakshmi Coin 20g', category: 'Coins & Bars', categorySlug: 'coins-bars', price: 1900, weight: '20g', purity: '999 Silver', image: 'https://images.pexels.com/photos/1191531/pexels-photo-1191531.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: false, is_new_arrival: true, description: 'Lakshmi embossed silver coin for Diwali gifting.' },
  { id: 14, name: 'Silver Hoop Earrings', category: 'Earrings', categorySlug: 'earrings', price: 3500, weight: '14g', purity: '925 Silver', image: 'https://images.pexels.com/photos/3641056/pexels-photo-3641056.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: true, is_new_arrival: false, description: 'Modern silver hoop earrings, lightweight and stylish.' },
  { id: 15, name: 'Silver Mangalsutra Chain', category: 'Chains', categorySlug: 'chains', price: 5500, weight: '20g', purity: '925 Silver', image: 'https://images.pexels.com/photos/1457801/pexels-photo-1457801.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: false, is_new_arrival: true, description: 'Silver mangalsutra chain with delicate pendant.' },
  { id: 16, name: 'Silver Diya Lamp', category: 'Pooja Items', categorySlug: 'pooja-items', price: 4500, weight: '40g', purity: '925 Silver', image: 'https://images.pexels.com/photos/248077/pexels-photo-248077.jpeg?auto=compress&cs=tinysrgb&w=600', is_featured: false, is_new_arrival: false, description: 'Pure silver diya lamp for daily pooja rituals.' },
];

const Store = () => {
  const navigate = useNavigate();
  const { category } = useParams();
  const [products, setProducts] = useState(DEFAULT_PRODUCTS);
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);
  const [selectedCategory, setSelectedCategory] = useState(category || 'all');
  const [sortBy, setSortBy] = useState('featured');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('http://localhost:5000/api/categories');
        if (response.data && response.data.length > 0) {
          setCategories(response.data);
        }
      } catch (error) {
        console.error('Using default categories');
      }
    };
    const fetchProducts = async () => {
      try {
        let url = 'http://localhost:5000/api/products';
        if (selectedCategory && selectedCategory !== 'all') {
          url += `?category=${selectedCategory}`;
        }
        const response = await axios.get(url);
        if (response.data && response.data.length > 0) {
          setProducts(response.data);
        }
      } catch (error) {
        console.error('Using default products');
      }
    };
    fetchCategories();
    fetchProducts();
  }, [selectedCategory]);

  useEffect(() => {
    if (category) {
      setSelectedCategory(category);
    }
  }, [category]);

  const filteredProducts = products
    .filter((product) => {
      const matchesCategory = selectedCategory === 'all' || 
        product.categorySlug === selectedCategory || 
        product.category?.toLowerCase() === selectedCategory.toLowerCase();
      const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        product.description?.toLowerCase().includes(searchQuery.toLowerCase());
      return matchesCategory && matchesSearch;
    })
    .sort((a, b) => {
      if (sortBy === 'price-low') return a.price - b.price;
      if (sortBy === 'price-high') return b.price - a.price;
      if (sortBy === 'name') return a.name.localeCompare(b.name);
      return 0;
    });

  return (
    <Box sx={{ backgroundColor: '#FBF9F7', minHeight: '100vh', py: { xs: 2, md: 4 } }}>
      <Container maxWidth="xl">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              mb: 1,
              fontWeight: 700,
              color: '#1A1A2E',
              fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
            }}
          >
            Our Silver Collection
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              mb: 4,
              color: '#555555',
            }}
          >
            Discover exquisite silver jewelry crafted with tradition and love
          </Typography>
        </motion.div>

        <Box sx={{ mb: 4 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search for silver jewelry..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#999' }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: '25px',
                    backgroundColor: '#fff',
                    '&:hover fieldset': { borderColor: '#D4AF37' },
                    '&.Mui-focused fieldset': { borderColor: '#1B1464' },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  value={selectedCategory}
                  label="Category"
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <MenuItem value="all">All Categories</MenuItem>
                  {categories.map((cat) => (
                    <MenuItem key={cat.id} value={cat.slug}>
                      {cat.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth>
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sortBy}
                  label="Sort By"
                  onChange={(e) => setSortBy(e.target.value)}
                >
                  <MenuItem value="featured">Featured</MenuItem>
                  <MenuItem value="price-low">Price: Low to High</MenuItem>
                  <MenuItem value="price-high">Price: High to Low</MenuItem>
                  <MenuItem value="name">Name: A to Z</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mb: 3, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip
            label="All"
            onClick={() => setSelectedCategory('all')}
            color={selectedCategory === 'all' ? 'primary' : 'default'}
            sx={{ cursor: 'pointer' }}
          />
          {categories.slice(0, 8).map((cat) => (
            <Chip
              key={cat.id}
              label={cat.name}
              onClick={() => setSelectedCategory(cat.slug)}
              color={selectedCategory === cat.slug ? 'primary' : 'default'}
              sx={{ cursor: 'pointer' }}
            />
          ))}
        </Box>

        <Grid container spacing={{ xs: 1.5, sm: 2, md: 3 }}>
          {filteredProducts.map((product, index) => (
            <Grid item xs={6} sm={6} md={4} lg={3} key={product.id}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                whileHover={{ y: -10 }}
              >
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                    borderRadius: 2,
                    overflow: 'hidden',
                    cursor: 'pointer',
                    transition: 'all 0.3s',
                    '&:hover': {
                      boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
                    },
                  }}
                  onClick={() => navigate(`/product/${product.id}`)}
                >
                  <Box sx={{ position: 'relative', paddingTop: '100%', overflow: 'hidden' }}>
                    <CardMedia
                      component="img"
                      image={product.image || 'https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=400'}
                      alt={product.name}
                      onError={(e) => { e.target.onerror = null; e.target.src = 'https://images.pexels.com/photos/265906/pexels-photo-265906.jpeg?auto=compress&cs=tinysrgb&w=400'; }}
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s',
                        '&:hover': {
                          transform: 'scale(1.1)',
                        },
                      }}
                    />
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        backgroundColor: 'rgba(255,255,255,0.85)',
                        '&:hover': { backgroundColor: 'white' },
                        zIndex: 2,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <FavoriteBorderIcon sx={{ fontSize: 18, color: '#1B1464' }} />
                    </IconButton>
                    {product.is_new_arrival && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 10,
                          left: 10,
                          backgroundColor: '#1B1464',
                          color: 'white',
                          px: 2,
                          py: 0.5,
                          borderRadius: 1,
                          fontSize: '0.75rem',
                          fontWeight: 600,
                        }}
                      >
                        NEW
                      </Box>
                    )}
                    {product.is_featured && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 10,
                          left: 10,
                          backgroundColor: '#D4AF37',
                          color: '#1A1A2E',
                          px: 2,
                          py: 0.5,
                          borderRadius: 1,
                          fontSize: '0.75rem',
                          fontWeight: 600,
                        }}
                      >
                        FEATURED
                      </Box>
                    )}
                  </Box>
                  <CardContent sx={{ flexGrow: 1, p: { xs: 1.5, md: 2 } }}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#1B1464',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: 1,
                        fontSize: { xs: '0.6rem', md: '0.75rem' },
                      }}
                    >
                      {product.category}
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                        fontSize: { xs: '0.8rem', md: '1rem' },
                      }}
                    >
                      {product.name}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                      {[...Array(5)].map((_, i) => (
                        <StarIcon key={i} sx={{ fontSize: 14, color: '#FFD700' }} />
                      ))}
                    </Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: '#1B1464',
                        fontWeight: 700,
                        fontSize: { xs: '0.9rem', md: '1.15rem' },
                      }}
                    >
                      ₹{product.price.toLocaleString()}
                    </Typography>
                    {product.weight && (
                      <Typography variant="caption" sx={{ color: '#666', display: { xs: 'none', sm: 'block' } }}>
                        {product.weight} | {product.purity}
                      </Typography>
                    )}
                  </CardContent>
                  <CardActions sx={{ p: { xs: 1, md: 2 }, pt: 0 }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      sx={{
                        borderColor: '#1B1464',
                        color: '#1B1464',
                        fontSize: { xs: '0.7rem', md: '0.85rem' },
                        py: { xs: 0.5, md: 1 },
                        '&:hover': {
                          borderColor: '#0F0D3D',
                          backgroundColor: '#1B1464',
                          color: 'white',
                        },
                      }}
                    >
                      View Details
                    </Button>
                  </CardActions>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        {filteredProducts.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h5" sx={{ color: '#666' }}>
              No products found
            </Typography>
            <Typography variant="body1" sx={{ color: '#999', mt: 1 }}>
              Try adjusting your search or filters
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Store;
